export const plurialize = (word: string, length: number) => {
  return `${length > 1 ? word + "s" : word}`;
};
